import type { TrainingVideo, TrainingVideosByCategory, UserTrainingMedia } from '@cobliteam/common-types';

export const graphQlTrainingVideoToTrainingVideo = (trainingVideos: TrainingVideo): TrainingVideo => ({
  id: trainingVideos.id,
  categoryId: trainingVideos.categoryId,
  name: trainingVideos.name,
  url: trainingVideos.url,
  thumbnail: trainingVideos.thumbnail,
  description: trainingVideos.description,
});

export const graphQlTrainingVideosByCategoryToTrainingVideoByCategory = (trainingVideos: TrainingVideosByCategory): TrainingVideosByCategory => ({
  category: trainingVideos.category,
  trainingVideos: trainingVideos.trainingVideos.map(graphQlTrainingVideoToTrainingVideo),
});

export const graphQlUserTrainingMediaToUserTrainingMedia = (userTrainingMedia: UserTrainingMedia): UserTrainingMedia => ({
  userId: userTrainingMedia.userId,
  trainingMediaId: userTrainingMedia.trainingMediaId,
  startedAt: userTrainingMedia.startedAt,
  finishedAt: userTrainingMedia.finishedAt,
  createdAt: userTrainingMedia.createdAt,
});
